import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import IntroductionTabs from '../../IntroductionTabs';
import BusinessDepartmentShowcase from './BusinessDepartmentShowcase';
import './businessfield.css';

const BusinessTransportPage = () => {
  const infraRef = useRef(null);
  const [chainInView, setChainInView] = useState(false);

  useEffect(() => {
    const el = infraRef.current;
    if (!el) return;
    if (typeof window !== 'undefined' && !('IntersectionObserver' in window)) {
      setChainInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setChainInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/business/transport';
  const title = '운송사업부 - 주식회사 가까운물류';
  const desc = '안전하고 신속한 화물 운송 서비스를 제공합니다.';

  const cards = [
    {
      title: '거래처 납품 서비스',
      description: '브랜드별 맞춤 납품\n안정적인 매장 공급',
      descVariant: 'preline',
    },
    {
    title: '온도 및 품질 관리',
    description: '냉장·냉동·상온별 철저한 관리 (신선·식자재 중심 프랜차이즈)',  
    descVariant: 'preline',
    },
    {
      title: '배송기사 관리 및 안전교육',
      description: '정기 교육 및 현장 중심 관리\n사고 예방 강화',
      descVariant: 'preline',
    },
    {
      title: '차량 관리 및 유지보수',
      description: '냉장·냉동 차량 관리\n식자재 신선도 보장',
      descVariant: 'preline',
    },
  ];

  return (
    <div className="business-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>

      <IntroductionTabs type="business">
        <div tabId="transport" className="business-content">
          <BusinessDepartmentShowcase
            headline={
              <>
                <span className="hl">운송사업부</span>는 안전하고 신속한 운송 운영을 기반으로
                <br />
                고객의 물류 품질을 책임집니다.
              </>
            }
            pill="현장 중심 운송 운영"
            pillDescription="납품부터 차량/인력 관리까지 단계별로 표준화된 운송 프로세스를 운영합니다."
            featureTitle="운송사업부의 특성"
            featureEmphasis="운송사업부는 신선 식자재를 정확하고 안전하게 배송하는 전문 물류 조직입니다."
            featureDescription="브랜드별 특성을 고려해 시간·온도·품질 기준을 지키며 안정적인 매장 공급을 지원합니다."
            centerLabel="운송사업부"
            cards={cards}
            layout="cardsRow"
          />

          {/* 운영 인프라 및 지사 구성 (운송사업부 - 본사/대구 지사) */}
          <section className="deptv2-infra" ref={infraRef}>
            <div className="deptv2-infra-inner deptv2-infra--vertical">
              <h3 className="deptv2-infra-title deptv2-infra-title--center">
                <span className="hl">주식회사 가까운물류</span>의 운영 인프라 및 지사 구성
              </h3>
              <p className="deptv2-infra-sub deptv2-infra-sub--center">
                본사를 중심으로 아래와 같은 단위 지사 조직을 운영하고 있습니다.
              </p>

              <div className={`deptv2-infra-chain deptv2-infra-chain--two ${chainInView ? 'is-in-view' : ''}`} aria-label="지사 구성 다이어그램">
                <div className="deptv2-chain-node deptv2-chain-node--core">본사</div>
                <div className="deptv2-chain-node deptv2-chain-node--branch deptv2-chain-node--daegu">대구 지사</div>
              </div>

              <div className="deptv2-infra-copy">
                <p className="deptv2-infra-copy-title">
                  <span className="hl">조직 구조를 기반으로</span>
                </p>
                <p className="deptv2-infra-copy-desc">
                  지역별 배송 환경과 물류 특성에 맞춘 운영이 가능하며,
                  <br />
                  <span className="hl">파트너사 모두에게</span> 안정적인 서비스를 제공합니다.
                </p>
              </div>
            </div>
          </section>
        </div>
      </IntroductionTabs>
    </div>
  );
};

export default BusinessTransportPage;
